import InputAdornment from "@mui/material/InputAdornment/InputAdornment";
import TextField from "@mui/material/TextField/TextField";
import makeStyles from "@mui/styles/makeStyles/makeStyles";

import ButtonComponent from "./button.component";

const useStyles = makeStyles(() => ({
  inputLight: {
    "& .MuiOutlinedInput-input::placeholder": {
      color: "#5C5C5C",
      fontSize: "1.46vh",
      fontWeight: "700",
    },
  },
  inputDark: {
    "& .MuiOutlinedInput-input::placeholder": {
      color: "white",
      fontSize: "1.46vh",
      fontWeight: "700",
    },
    "& .MuiOutlinedInput-root": {
      color: "#5C5C5C",
      fontWeight: "400",
      fontSize: "1.46vh",
      "& fieldset": {
        borderRadius: "10px",
        borderColor: "#C4C4C4",
      },
      "&:hover fieldset": {
        borderRadius: "10px",
        borderColor: "#C4C4C4",
      },
      "&.Mui-focused fieldset": {
        borderRadius: "10px",
        borderColor: "#C4C4C4",
      },
    },
  },
}));

const InputWithButtonComponent = ({
  placeholder,
  buttonLabel,
  value,
  onClick,
  width,
  backgroundColor,
  color,
  onChange,
  errorMessage,
  isLight,
  type,
  disabled,
}) => {
  const classes = useStyles();

  return (
    <TextField
      variant="outlined"
      placeholder={placeholder}
      fullWidth
      className={!!isLight ? classes.inputLight : classes.inputDark}
      style={{ width: width, color: color }}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      error={!!errorMessage}
      helperText={errorMessage}
      type={type}
      disabled={disabled}
      InputProps={{
        style: {
          backgroundColor: backgroundColor,
          color: color,
          borderRadius: "10px",
          height: "5.5vh",
        },
        endAdornment: (
          <InputAdornment position="end">
            <ButtonComponent
              label={buttonLabel}
              height="4vh"
              backgroundColor={isLight ? "#774E98" : "white"}
              color={isLight ? "white" : "#C4C4C4"}
              borderRadius="10px"
              onClick={onClick}
            />
          </InputAdornment>
        ),
      }}
    />
  );
};

export default InputWithButtonComponent;
